// extracted by mini-css-extract-plugin
module.exports = {"root":"_3Gi2v","border":"AaBQM","row":"_2HfH2","noWrap":"_3pV81"};